import React from 'react';
import styled from 'styled-components';

import {
  Fade,
  IconButton,
  ListItemText,
  Menu,
  MenuItem,
  MenuList,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

function GameHeader(props) {
  const {
    corporation,
    toggleFullScreen,
    showTutorial,
    toggleTutorial,
    resetGameState,
    handleMenuClick,
    open,
    anchorEl,
    handleClose,
  } = props;

  const { bgColor, color, description, effect, name, outline, symbol } =
    corporation;

  const nameStyles = {
    color: color,
    outline: outline,
    bgColor: bgColor,
  };

  const fullScreenMode = Boolean(document.fullscreenElement);

  return (
    <Header>
      <CorpName sx={nameStyles}>
        {symbol}
        {name}
      </CorpName>
      <div className="corp-data">
        <p className="desc">{description}</p>
        {effect ? <p className="desc">{effect}</p> : null}
      </div>

      <IconButton onClick={handleMenuClick}>
        <MenuIcon color="primary" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        <MenuList>
          <MenuItem onClick={toggleFullScreen}>
            <ListItemText>
              {fullScreenMode ? 'Exit' : 'Enter'} Fullscreen
            </ListItemText>
          </MenuItem>
          <MenuItem onClick={toggleTutorial}>
            <ListItemText>
              {showTutorial ? 'Stop' : 'Start'} Tutorial Walkthrough
            </ListItemText>
          </MenuItem>
          <MenuItem onClick={resetGameState}>
            <ListItemText>Reset Game State</ListItemText>
          </MenuItem>
        </MenuList>
      </Menu>
    </Header>
  );
}

const Header = styled.header`
  height: 50px;
  background-color: #222;
  color: white;
  font-size: 2rem;
  display: grid;
  grid-template-columns: auto 1fr auto auto;
  gap: 20px;
  align-items: center;
  padding: 0 1% 0 0;

  .corp-data {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .desc {
    font-size: 0.8rem;
    text-align: center;
  }
  .tr {
    margin-left: auto;
    color: firebrick;
  }
`;

const CorpName = styled.h1`
  height: 100%;
  font-size: 1.8rem;
  padding: 3px 8px;
  font-weight: 900;
  color: ${({ sx }) => sx.color};
  background-color: ${({ sx }) => sx.bgColor};
  border: 4px solid ${({ sx }) => sx.color};
`;

export default GameHeader;
